import React from "react";
import { UIFlightData } from "@flights/types";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller";
import Frame from "../../../../../Frame";
import { Text } from "@bookingcom/bui-react";

const useUpgradeFareInfoDesktop = (flight: UIFlightData) => {
  const { header, subheader, fareInfoContent } = useUpgradeFareInfoController(flight);

  if (!fareInfoContent) return undefined;

  return {
    header,
    subheader,
    content: (
      <Frame direction="row" justifyContent="space-between">
        <Frame>
          <Text variant="body_2">{fareInfoContent.content}</Text>
          <Text variant="body_2">{fareInfoContent.price}</Text>
        </Frame>
        <Frame ml={4}>
          <Text variant="body_2" align="right" wrap="nowrap">
            {fareInfoContent.supportText}
          </Text>
        </Frame>
      </Frame>
    )
  };
};

export default useUpgradeFareInfoDesktop;
